const QUILL_CSS_URL = "https://cdn.quilljs.com/1.3.6/quill.snow.css";

const WRAPPER_PREFIX = `<html><head><link rel='stylesheet' href= '${QUILL_CSS_URL}' /></head><body><div class='ql-editor' style='overflow: visible;' data-gramm='false' contenteditable='true'>`;
const WRAPPER_SUFFIX = `</div></body></html>`;

export function formatarPeca(conteudoEditor: string): string {
  // evita undefined/null virar "undefined"
  const html = conteudoEditor ?? "";
  return `${WRAPPER_PREFIX}${html}${WRAPPER_SUFFIX}`;
}

export function desformatarPeca(txPeca: string): string {
  if (!txPeca) return "";

  // se já estiver "crua", não mexe
  if (!txPeca.includes("ql-editor") || !txPeca.includes("<html")) {
    return txPeca;
  }

  // remove wrapper do legado (mesmo padrão do C#)
  return txPeca.replace(WRAPPER_PREFIX, "").replace(WRAPPER_SUFFIX, "");
}

export function isPecaFormatada(txPeca: string): boolean {
  return (
    !!txPeca && txPeca.startsWith("<html>") && txPeca.includes("ql-editor")
  );
}
